import { useCallback, useEffect, useState } from "react";
import { apiV1 } from "./api";
import { useAuth } from "../context/AuthContext";

export const Plans = {
  catalog: () => apiV1.get("/plans").then((r) => r.data),
  me: () => apiV1.get("/plans/me").then((r) => r.data),
  checkout: (tier) => apiV1.post("/plans/checkout", { tier, origin_url: window.location.origin }).then((r) => r.data),
  checkoutStatus: (id) => apiV1.get(`/plans/checkout/status/${id}`).then((r) => r.data),
  cancel: () => apiV1.post("/plans/cancel").then((r) => r.data),
  resume: () => apiV1.post("/plans/resume").then((r) => r.data),
  portal: () => apiV1.post("/plans/portal", { origin_url: window.location.origin }).then((r) => r.data),
  addonCheckout: () => apiV1.post("/plans/addon/checkout", { origin_url: window.location.origin }).then((r) => r.data),
  addonStatus: (id) => apiV1.get(`/plans/addon/status/${id}`).then((r) => r.data),
  consume: (count, speed, label, ai = false) => apiV1.post("/credits/consume", { count, speed, label, ai }).then((r) => r.data),
  describe: (batch_id, filename, image_base64) => apiV1.post("/ai/describe", { batch_id, filename, image_base64 }).then((r) => r.data),
  change: (tier) => apiV1.post("/plans/change", { tier }).then((r) => r.data),
  refund: (batch_id, count) => apiV1.post("/credits/refund", { batch_id, count }).then((r) => r.data),
  batches: () => apiV1.get("/credits/batches").then((r) => r.data.items),
  usage: (months = 6) => apiV1.get("/credits/usage", { params: { months } }).then((r) => r.data),
};

export const errText = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

// Live plan + credits for the signed-in user; `set` lets callers push fresh status.
export function usePlan() {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  const refresh = useCallback(() => {
    if (!user) { setPlan(null); return Promise.resolve(null); }
    return Plans.me().then((p) => { setPlan(p); return p; }).catch(() => null);
  }, [user]);
  useEffect(() => { refresh(); }, [refresh]);
  return { plan, refresh, set: setPlan };
}

export const daysLeft = (iso) => (iso ? Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86400000)) : null);
